import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-panel-footer',
  templateUrl: './panel-footer.component.html',
  styleUrls: ['./panel-footer.component.scss']
})
export class PanelFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
